export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      airport: 'Aéroport YUL',
      services: 'Services',
      fares: 'Tarifs',
      areas: 'Zones desservies',
      faq: 'FAQ',
      contact: 'Contact',
    },
    hero: {
      title: 'Le service de taxi le plus fiable de Montréal',
      subtitle: 'Ramassage rapide, tarifs fixes pour l\'aéroport et service 24/7 dans tout le Grand Montréal.',
      callNow: 'Appeler',
      bookOnline: 'Réserver en ligne',
      downloadApp: 'Télécharger l\'appli',
    },
    services: {
      title: 'Nos Services',
      subtitle: 'Un service de taxi complet pour tous vos besoins de transport',
      sedan: {
        title: 'Berline Standard',
        desc: 'Pour vos déplacements quotidiens, confortable et économique.',
      },
      minivan: {
        title: 'Taxi Minivan',
        desc: 'Idéal pour les groupes jusqu\'à 6 passagers avec bagages.',
      },
      accessible: {
        title: 'Taxi Accessible',
        desc: 'Véhicules adaptés pour les fauteuils roulants.',
      },
      corporate: {
        title: 'Comptes Corporatifs',
        desc: 'Solutions de transport pour entreprises avec facturation mensuelle.',
      },
      airport: {
        title: 'Navette Aéroport',
        desc: 'Service fiable vers l\'Aéroport Montréal-Trudeau (YUL).',
      },
      express: {
        title: 'Services Express',
        desc: 'Survoltage, déverrouillage et livraison de colis.',
      },
    },
    airport: {
      title: 'Service Taxi Aéroport YUL',
      subtitle: 'Navette fiable vers l\'Aéroport International Montréal-Trudeau',
      intro: 'MTL Taxi offre un service de navette professionnel vers et depuis l\'Aéroport Montréal-Trudeau (YUL). Nos chauffeurs expérimentés vous garantissent un transport ponctuel et confortable.',
      features: {
        title: 'Pourquoi choisir MTL Taxi pour l\'aéroport?',
        tracking: 'Suivi des vols en temps réel',
        available: 'Disponible 24/7, tous les jours',
        fixed: 'Tarifs fixes par zone',
        comfortable: 'Véhicules confortables et climatisés',
        luggage: 'Espace pour vos bagages',
        professional: 'Chauffeurs professionnels',
      },
      rates: {
        title: 'Tarifs Aéroport par Zone',
        subtitle: 'Prix approximatifs depuis/vers l\'Aéroport YUL (en dollars canadiens)',
        zone: 'Zone',
        price: 'Prix approx.',
        note: 'Les prix sont approximatifs et peuvent varier selon le trafic. Tarif de nuit majoré de 15%.',
      },
    },
    fares: {
      title: 'Tarifs de Taxi',
      subtitle: 'Tarifs réglementés par la Commission des transports du Québec',
      howItWorks: {
        title: 'Comment se calcule le coût d\'une course?',
        intro: 'Le coût d\'une course en taxi se compose de trois éléments principaux:',
        departure: 'Prix de départ affiché au compteur au début de la course',
        perKm: 'Prix par kilomètre parcouru',
        waiting: 'Prix par heure d\'attente ou d\'immobilisation',
      },
      current: {
        title: 'Tarifs en vigueur',
        dayRate: 'Tarif de jour (5h à 22h59)',
        nightRate: 'Tarif de nuit (23h à 4h59)',
        departure: 'Départ',
        perKm: 'Par km',
        waiting: 'Attente/heure',
      },
      note: 'Ces tarifs incluent les taxes et une redevance additionnelle de 1,05$ par course.',
      moreInfo: 'Pour plus de détails, consultez',
      ctqLink: 'la Commission des transports du Québec',
    },
    areas: {
      title: 'Zones Desservies',
      subtitle: 'Service de taxi dans tout le Grand Montréal',
      intro: 'MTL Taxi dessert l\'ensemble du Grand Montréal et ses environs. Consultez notre carte interactive pour voir nos zones de service.',
      zones: {
        montreal: 'Montréal Centre',
        westIsland: 'Ouest-de-l\'Île',
        laval: 'Laval',
        southShore: 'Rive-Sud',
        northShore: 'Rive-Nord',
      },
      mainAreas: 'Principales zones desservies',
      available: 'Service disponible 24/7',
    },
    faq: {
      title: 'Questions Fréquentes',
      subtitle: 'Trouvez les réponses à vos questions',
      questions: [
        {
          q: 'Comment puis-je réserver un taxi?',
          a: 'Vous pouvez réserver par téléphone au 438-600-4440, via notre application mobile (iOS/Android), ou en ligne sur notre site de réservation.',
        },
        {
          q: 'Quels modes de paiement acceptez-vous?',
          a: 'Nous acceptons les paiements en espèces, par carte de débit, Visa, Mastercard et American Express.',
        },
        {
          q: 'Proposez-vous des véhicules pour personnes à mobilité réduite?',
          a: 'Oui, nous avons des véhicules adaptés pour les fauteuils roulants. Veuillez le mentionner lors de votre réservation.',
        },
        {
          q: 'Combien de passagers peuvent monter dans un taxi?',
          a: 'Une berline standard peut accueillir jusqu\'à 4 passagers. Pour les groupes de 5-6 personnes, réservez un minivan.',
        },
        {
          q: 'Les animaux de compagnie sont-ils acceptés?',
          a: 'Les chiens d\'assistance sont toujours acceptés par la loi. Pour les autres animaux, c\'est à la discrétion du chauffeur. Veuillez nous prévenir à l\'avance.',
        },
        {
          q: 'Offrez-vous un service de navette aéroport?',
          a: 'Oui, nous offrons un service fiable 24/7 vers l\'Aéroport Montréal-Trudeau (YUL) avec tarifs fixes par zone.',
        },
        {
          q: 'J\'ai oublié un objet dans le taxi, que faire?',
          a: 'Contactez-nous immédiatement au 438-600-4440 avec la date, l\'heure et la destination de votre course. Nous ferons notre possible pour retrouver votre objet.',
        },
        {
          q: 'Offrez-vous d\'autres services que le transport?',
          a: 'Oui! Nous offrons le survoltage de batterie (25$), le déverrouillage de porte (30$) et la livraison de colis.',
        },
      ],
    },
    contact: {
      title: 'Contactez-Nous',
      subtitle: 'Nous sommes disponibles 24 heures sur 24, 7 jours sur 7',
      phone: 'Téléphone',
      hours: 'Heures',
      hoursValue: '24/7 - Tous les jours',
      payment: 'Paiement',
      paymentMethods: 'Comptant, Débit, Visa, Mastercard, Amex',
      service: 'Zone de service',
      serviceArea: 'Grand Montréal et environs',
      bookOnline: 'Réserver en ligne',
      bookDesc: 'Réservez votre taxi en quelques clics via notre système de réservation en ligne.',
      appTitle: 'Téléchargez notre application',
      appDesc: 'Commandez, réservez et suivez votre taxi directement depuis votre téléphone.',
    },
    footer: {
      tagline: 'Votre taxi de confiance à Montréal',
      quickLinks: 'Liens rapides',
      legal: 'Informations légales',
      privacy: 'Politique de confidentialité',
      terms: 'Conditions d\'utilisation',
      disclaimer: 'Avertissement',
      followUs: 'Suivez-nous',
      rights: 'Tous droits réservés.',
    },
    cta: {
      callNow: 'Appeler',
      book: 'Réserver',
    },
  },
  en: {
    nav: {
      home: 'Home',
      airport: 'YUL Airport',
      services: 'Services',
      fares: 'Fares',
      areas: 'Service Areas',
      faq: 'FAQ',
      contact: 'Contact',
    },
    hero: {
      title: 'Montreal\'s Most Reliable Taxi Service',
      subtitle: 'Fast pickups, fixed airport rates, and 24/7 service across Greater Montreal.',
      callNow: 'Call Now',
      bookOnline: 'Book Online',
      downloadApp: 'Download App',
    },
    services: {
      title: 'Our Services',
      subtitle: 'Complete taxi service for all your transportation needs',
      sedan: {
        title: 'Standard Sedan',
        desc: 'For your daily trips, comfortable and economical.',
      },
      minivan: {
        title: 'Minivan Taxi',
        desc: 'Ideal for groups up to 6 passengers with luggage.',
      },
      accessible: {
        title: 'Accessible Taxi',
        desc: 'Wheelchair accessible vehicles available.',
      },
      corporate: {
        title: 'Corporate Accounts',
        desc: 'Business transportation solutions with monthly billing.',
      },
      airport: {
        title: 'Airport Shuttle',
        desc: 'Reliable service to Montreal-Trudeau Airport (YUL).',
      },
      express: {
        title: 'Express Services',
        desc: 'Battery boost, door unlock, and parcel delivery.',
      },
    },
    airport: {
      title: 'YUL Airport Taxi Service',
      subtitle: 'Reliable shuttle to Montreal-Trudeau International Airport',
      intro: 'MTL Taxi offers professional shuttle service to and from Montreal-Trudeau Airport (YUL). Our experienced drivers guarantee punctual and comfortable transportation.',
      features: {
        title: 'Why choose MTL Taxi for the airport?',
        tracking: 'Real-time flight tracking',
        available: 'Available 24/7, every day',
        fixed: 'Fixed rates by zone',
        comfortable: 'Comfortable, air-conditioned vehicles',
        luggage: 'Space for your luggage',
        professional: 'Professional drivers',
      },
      rates: {
        title: 'Airport Rates by Zone',
        subtitle: 'Approximate prices from/to YUL Airport (in Canadian dollars)',
        zone: 'Zone',
        price: 'Approx. Price',
        note: 'Prices are approximate and may vary with traffic. Night rate 15% higher.',
      },
    },
    fares: {
      title: 'Taxi Fares',
      subtitle: 'Rates regulated by the Commission des transports du Québec',
      howItWorks: {
        title: 'How is the fare calculated?',
        intro: 'The cost of a taxi ride consists of three main elements:',
        departure: 'Starting fare displayed on the meter at the beginning of the ride',
        perKm: 'Price per kilometer traveled',
        waiting: 'Price per hour of waiting or standing',
      },
      current: {
        title: 'Current Rates',
        dayRate: 'Day rate (5am to 10:59pm)',
        nightRate: 'Night rate (11pm to 4:59am)',
        departure: 'Starting',
        perKm: 'Per km',
        waiting: 'Waiting/hour',
      },
      note: 'These rates include taxes and an additional fee of $1.05 per ride.',
      moreInfo: 'For more details, visit',
      ctqLink: 'the Commission des transports du Québec',
    },
    areas: {
      title: 'Service Areas',
      subtitle: 'Taxi service throughout Greater Montreal',
      intro: 'MTL Taxi serves all of Greater Montreal and surrounding areas. Check our interactive map to see our service zones.',
      zones: {
        montreal: 'Montreal Centre',
        westIsland: 'West Island',
        laval: 'Laval',
        southShore: 'South Shore',
        northShore: 'North Shore',
      },
      mainAreas: 'Main service areas',
      available: 'Service available 24/7',
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Find answers to your questions',
      questions: [
        {
          q: 'How can I book a taxi?',
          a: 'You can book by phone at 438-600-4440, via our mobile app (iOS/Android), or online through our booking system.',
        },
        {
          q: 'What payment methods do you accept?',
          a: 'We accept cash, debit card, Visa, Mastercard, and American Express.',
        },
        {
          q: 'Do you have wheelchair accessible vehicles?',
          a: 'Yes, we have wheelchair accessible vehicles. Please mention this when booking.',
        },
        {
          q: 'How many passengers can fit in a taxi?',
          a: 'A standard sedan can accommodate up to 4 passengers. For groups of 5-6, book a minivan.',
        },
        {
          q: 'Are pets allowed?',
          a: 'Service dogs are always allowed by law. For other pets, it\'s at the driver\'s discretion. Please let us know in advance.',
        },
        {
          q: 'Do you offer airport shuttle service?',
          a: 'Yes, we offer reliable 24/7 service to Montreal-Trudeau Airport (YUL) with fixed rates by zone.',
        },
        {
          q: 'I left something in the taxi, what should I do?',
          a: 'Contact us immediately at 438-600-4440 with the date, time, and destination of your trip. We\'ll do our best to find your item.',
        },
        {
          q: 'Do you offer services other than transportation?',
          a: 'Yes! We offer battery boost ($25), door unlock ($30), and parcel delivery.',
        },
      ],
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'We\'re available 24 hours a day, 7 days a week',
      phone: 'Phone',
      hours: 'Hours',
      hoursValue: '24/7 - Every day',
      payment: 'Payment',
      paymentMethods: 'Cash, Debit, Visa, Mastercard, Amex',
      service: 'Service Area',
      serviceArea: 'Greater Montreal and surroundings',
      bookOnline: 'Book Online',
      bookDesc: 'Book your taxi in a few clicks through our online booking system.',
      appTitle: 'Download our app',
      appDesc: 'Order, book, and track your taxi directly from your phone.',
    },
    footer: {
      tagline: 'Your trusted taxi in Montreal',
      quickLinks: 'Quick Links',
      legal: 'Legal Information',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use',
      disclaimer: 'Disclaimer',
      followUs: 'Follow Us',
      rights: 'All rights reserved.',
    },
    cta: {
      callNow: 'Call Now',
      book: 'Book',
    },
  },
};

export const airportRates = {
  montreal: [
    { zone: 'Centre-ville / Downtown', price: '48$' },
    { zone: 'Ahuntsic', price: '43$' },
    { zone: 'Anjou', price: '60$' },
    { zone: 'Côte-des-Neiges / NDG', price: '32$' },
    { zone: 'Hochelaga-Maisonneuve', price: '59$' },
    { zone: 'Lachine', price: '22$' },
    { zone: 'LaSalle', price: '30$' },
    { zone: 'Le Plateau-Mont-Royal', price: '54$' },
    { zone: 'Montréal-Nord', price: '58$' },
    { zone: 'Outremont', price: '40$' },
    { zone: 'Rosemont', price: '45$' },
    { zone: 'Saint-Laurent', price: '37$' },
    { zone: 'Saint-Léonard', price: '55$' },
    { zone: 'Verdun', price: '47$' },
    { zone: 'Villeray', price: '41$' },
  ],
  westIsland: [
    { zone: 'Dorval', price: '12$' },
    { zone: 'Pointe-Claire', price: '24$' },
    { zone: 'Kirkland', price: '35$' },
    { zone: 'Beaconsfield', price: '34$' },
    { zone: 'Dollard-Des-Ormeaux', price: '43$' },
    { zone: 'Pierrefonds', price: '38$' },
    { zone: 'Île-Bizard', price: '53$' },
  ],
  laval: [
    { zone: 'Chomedey', price: '41$' },
    { zone: 'Laval-des-Rapides', price: '50$' },
    { zone: 'Sainte-Dorothée', price: '39$' },
    { zone: 'Fabreville', price: '49$' },
    { zone: 'Pont-Viau', price: '55$' },
    { zone: 'Vimont', price: '65$' },
    { zone: 'Auteuil', price: '81$' },
  ],
  southShore: [
    { zone: 'Longueuil', price: '78$' },
    { zone: 'Brossard', price: '65$' },
    { zone: 'Saint-Lambert', price: '65$' },
    { zone: 'Boucherville', price: '97$' },
    { zone: 'Saint-Hubert', price: '77$' },
    { zone: 'Châteauguay', price: '57$' },
    { zone: 'La Prairie', price: '72$' },
  ],
};
